/**
 * ImportMap is a JSON object that describes the mapping of bare module specifiers to URLs.
 */
export interface ImportMap {
  imports: Record<string, string>;
  scopes?: Record<string, Record<string, string>>;
}
